import { SubscriptionResponse } from "@shared/types/common";
import { useSubscriptionsStore } from "@shared/stores/subscriptions.ts";
import { SubscriptionDTO } from "@shared/types/common";

export default async () => {
  const subscriptionStore = useSubscriptionsStore();
  return {
    subscription:
      subscriptionStore.currentSubscription || ({} as SubscriptionDTO),
  } satisfies SubscriptionResponse;
};
